import { Grid, Typography, Box } from "@mui/material";
import "../assets/css/ticket-card.css";
import { Link } from "react-router-dom";
import React from "react";
import UserAvatar from "./UserAvatar";
import moment from "moment";
import { userData } from "../config";
import { useLocation } from "react-router-dom";

function TicketCard(data) {
  const location = useLocation();

  const getApprovalChipStyles = (status) => {
    if (status === "Approve" || status === "Approved") {
      return { backgroundColor: "#e8f5e9", color: "#2e7d32" };
    } else if (status === "Decline" || status === "Declined") {
      return { backgroundColor: "#ffebee", color: "#d32f2f" };
    } else {
      return { backgroundColor: "#fff8e1", color: "#f57f17" };
    }
  };

  // Show exactly what the API returns — only fallback if truly null/undefined/empty
  const rawApproval = data.data.approvalStatus;
  const approvalStatus =
    rawApproval != null && rawApproval !== "" ? rawApproval : "Not Approved";

  const approvalChipStyles = getApprovalChipStyles(approvalStatus);
  const statusID = data.data.ticketCloseStatusID;

  const getStatusBorderColor = () => {
    switch (statusID) {
      case 45:
        return data.data.submitted_by_admin === true || data.data.submitted_by_admin === 1
          ? "#0097a7"
          : "#ad1457";
      case 47: return "#ed6c02";
      case 48: return "#2e7d32";
      case 49: return "#7b1fa2";
      case 46: return "#f9a825";
      case 44: return "#c62828";
      case 74: return "#0288d1";
      case 187: return "#00796b";
      default: return "transparent";
    }
  };

  return (
    <>
      <Grid className="card" sx={{ height: "100%" }}>
        <Grid className="cardContent" sx={{ height: "100%" }}>
          <Grid className="innerCardContent" sx={{ height: "100%" }}>
            <Link className="w-100" to={data.data.ticketRedirect}>
              <Grid
                className={[data.data.ticketStatusClass, "innerCardContent1"]}
                sx={{
                  borderLeft: `6px solid ${getStatusBorderColor()}`,
                  display: "flex",
                  flexDirection: "column",
                  height: "100%",
                }}
              >
                {/* Card Header */}
                <Grid
                  container
                  className="card-header"
                  spacing={1.5}
                  wrap="nowrap"
                  sx={{ padding: "12px 14px 0 14px" }}
                >
                  <Grid item>
                    <UserAvatar name={data.data.ticketType} />
                  </Grid>
                  <Grid item xs zeroMinWidth>
                    {/* Ticket Type + Admin Badge */}
                    <Box display="flex" flexWrap="wrap" alignItems="center" gap={0.75} mb={0.4}>
                      <Typography
                        className={[data.data.ticketType, "ticket-type"]}
                        sx={{ fontWeight: 700, fontSize: "13px" }}
                      >
                        {data.data.ticketType}
                      </Typography>
                      {data.data.submitted_by_admin && (
                        <Box
                          component="span"
                          sx={{
                            backgroundColor: "#2e7d32",
                            color: "white",
                            fontSize: "10px",
                            fontWeight: "700",
                            padding: "2px 7px",
                            borderRadius: "12px",
                            textTransform: "uppercase",
                            display: "inline-block",
                            lineHeight: "1.4",
                          }}
                        >
                          Created by Admin
                        </Box>
                      )}
                    </Box>

                    {/* Ticket Subject */}
                    <Typography
                      className="cardHeading"
                      sx={{
                        fontSize: "15px",
                        fontWeight: "800",
                        color: "#3f1d62",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        mb: 0.5,
                      }}
                    >
                      {data.data.ticketSubject}
                    </Typography>

                    {/* Category */}
                    <Typography
                      className="ticket-details"
                      sx={{ fontSize: "12px", color: "#7b809a", mb: 0.5 }}
                    >
                      Category: {data.data.ticketCategory}
                    </Typography>

                    {/* Status Row */}
                    <Box
                      sx={{
                        minHeight: "45px",
                        display: "flex",
                        alignItems: "center",
                        gap: 0.5,
                        flexWrap: "wrap",
                        mb: 0.5,
                      }}
                    >
                      {statusID === 48 ? (
                        // statusID 48 = Closed — show CLOSED chip only, NO department status
                        data.data.auto_close ? (
                          <Box
                            component="span"
                            sx={{
                              backgroundColor: "#fbe9e7",
                              color: "#bf360c",
                              fontSize: "11px",
                              fontWeight: "700",
                              padding: "2px 10px",
                              borderRadius: "4px",
                              textTransform: "uppercase",
                            }}
                          >
                            Auto Closed
                          </Box>
                        ) : (
                          <Box
                            component="span"
                            sx={{
                              backgroundColor: "#e3f2fd",
                              color: "#1976d2",
                              fontSize: "11px",
                              fontWeight: "700",
                              padding: "2px 10px",
                              borderRadius: "4px",
                              textTransform: "uppercase",
                            }}
                          >
                            Closed
                          </Box>
                        )
                      ) : (
                        // All other statuses — show exactly what API returns as approvalStatus
                        <>
                          <Typography
                            className="ticket-details"
                            sx={{ fontSize: "12px", color: "#7b809a", whiteSpace: "nowrap" }}
                          >
                            Department Status :
                          </Typography>
                          <Box
                            component="span"
                            sx={{
                              ...approvalChipStyles,
                              fontSize: "11px",
                              fontWeight: "700",
                              padding: "2px 10px",
                              borderRadius: "4px",
                              textTransform: "uppercase",
                            }}
                          >
                            {approvalStatus}
                          </Box>
                        </>
                      )}
                    </Box>
                  </Grid>
                </Grid>

                {/* Divider */}
                <hr className="hrLine" />

                {/* Card Footer */}
                <Grid className="cardBody" sx={{ padding: "4px 14px 10px 14px" }}>
                  <Typography className="cardDetails">
                    <Typography className="cardSubHeading cardContentDetails">
                      {data.data.ticketCreatedUserName}
                    </Typography>
                    <Typography className="cardContentDetails">
                      Created at: {moment
                        .utc(data.data.ticketCreatedAt)
                        .utcOffset("+05:30")
                        .format("MMM DD, YYYY, hh:mm A")}
                    </Typography>
                    <Typography className="cardContentDetails" sx={{ mt: 0.5, fontStyle: 'italic', color: '#1976d2' }}>
                      IT Admin : {data.data.lastAgentReplyName ? data.data.lastAgentReplyName : "-"}
                    </Typography>
                  </Typography>
                </Grid>
              </Grid>
            </Link>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
}
export default TicketCard;